import {StudyType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {TabState, TabStateDefaults} from 'Navigation';

class StudyDesignTabState extends TabState {
  constructor(attributes: {studyId: string; studyType: StudyType}, options?: unknown) {
    super(attributes, options);
  }

  studyId(): string {
    return this.get('studyId');
  }

  studyType(): StudyType {
    return this.get('studyType');
  }

  override defaults(): TabStateDefaults {
    return {
      ...super.defaults(),
      title: 'Design',
      closeable: false,
      preferenceKey: 'study-design',
    };
  }
}

export default StudyDesignTabState;
